import moment from 'moment-timezone'
import { useMemo } from 'react'
import { allTimezones, useTimezoneSelect } from 'react-timezone-select'
import { PatientVisitTag, Tooltip } from 'ui_kit_qmd'
import { useSelector } from 'react-redux'
import { getAge, getFullName, getTimeZones, parseTimeZone, parseUserDateTime } from '../../../../utils/common'
import {
  DOB_TEXT,
  MAT_MOUD_TEXT,
  MRN_TEXT,
  PROVIDER_TEXT,
  STATUS_TEXT,
  VISIT_DATE_TIME_TEXT,
} from '../../../../utils/constants'
import { UNASSIGNED_PROVIDER_TEXT } from '../../../visits/constants'
import { PatientInfoCardRows } from '../patient-info-card-rows/PatientInfoCardRows'
import './PatientInfoCard.scss'
import { formatPatientTime } from '../../helper'
import { DATE_FORMAT_SLASH } from '../../../../utils/dateUtils'
import { ProgramVisitBadge } from '@/components/program-visit-badge/ProgramVisitBadge'
import { GrantVisitBadge } from '@/components/grant-visit-badge/GrantVisitBadge'
import { readVisitCoverage } from '@quickmd-llc/frontend-utils'

export const PatientInfoCard = ({
  patient = {},
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  provider,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  method,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  status,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitType,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  userTimeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  hasMatMoud,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientTimeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isUpcomingVisit,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitId,
}) => {
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const visitInfo = useSelector((state) => state.pastVisitReducer.pastVisitsInfo?.[visitId]?.visitInfo ?? {})

  const timezones = getTimeZones(allTimezones)
  const { parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'abbrOnly' })
  const parsedPatientTimeZoneValue =
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    parseTimezone(patientTimeZone)?.label ?? parseTimezone(parseTimeZone(patientTimeZone ?? ''))?.value
  const parsedPatientTimeZoneAbbr =
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    parseTimezone(patientTimeZone)?.label ?? parseTimezone(parseTimeZone(patientTimeZone ?? ''))?.label
  const parsedAdminTimeZoneAbbr =
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    parseTimezone(userTimeZone)?.label ?? parseTimezone(parseTimeZone(userTimeZone ?? ''))?.label

  const visitDateTimeTextValue = `${parseUserDateTime(
    visitDateTime,
    userTimeZone,
    true,
  )} ${parsedAdminTimeZoneAbbr} ${formatPatientTime(
    visitDateTime,
    parsedPatientTimeZoneValue,
    parsedPatientTimeZoneAbbr,
  )}`

  const mockPatientInfoConfig = useMemo(
    () => [
      [
        {
          key: `${DOB_TEXT}:`,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          value: moment(patient.BirthDate).format(DATE_FORMAT_SLASH),
        },
        {
          key: `${MRN_TEXT}:`,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          value: patient.MedicalRecordNumber,
        },
      ],
      {
        key: `${VISIT_DATE_TIME_TEXT}:`,
        value: visitDateTimeTextValue,
      },
      {
        key: `${PROVIDER_TEXT}:`,
        value: provider && Object.keys(provider).length ? getFullName(provider) : UNASSIGNED_PROVIDER_TEXT,
      },
      [
        {
          id: 'patient-info-card-visit-type-name',
          visitType: method,
          value: visitType,
        },
        {
          className: 'patient-info-card-mat-moud',
          value: hasMatMoud && MAT_MOUD_TEXT,
        },
        {
          key: `${STATUS_TEXT}:`,
          value: `${status.charAt(0)?.toUpperCase()}${status.slice(1)}`,
        },
      ],
    ],
    [
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      patient.BirthDate,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      patient.MedicalRecordNumber,
      visitDateTimeTextValue,
      provider,
      method,
      visitType,
      hasMatMoud,
      status,
    ],
  )

  return (
    <div className='patient-info-card-main-wrapper'>
      <div className='patient-info-card-name-wrapper'>
        {/*
         // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered */}
        <Tooltip targetId='patient-info-card-patient-name' content={`${patient.FirstName} ${patient.LastName}`}>
          <div id='patient-info-card-patient-name' className='patient-info-card-name'>
            {/*
             // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered */}
            {`${patient.FirstName} ${patient.LastName}`}
          </div>
        </Tooltip>
        <div className='patient-info-card-gender-block'>
          {/*
           // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered */}
          ({getAge(moment(patient.BirthDate)).toString()}/{patient.Gender === 'male' ? 'M' : 'F'})
        </div>
        {isUpcomingVisit ?
          <PatientVisitTag
            className='patient-info-card-visit-tag'
            isNewForServiceType={visitInfo?.IsNewForServiceType}
            isNewForPatient={visitInfo?.IsNewForPatient}
          />
        : null}
        {/* Past visits get the chip too: `Position` is fixed for a visit's life, so it
            states what that visit was rather than reading the current balance. */}
        <ProgramVisitBadge className='ml-sp-1 shrink-0 self-center' coverage={readVisitCoverage(visitInfo)} />
        {/* A grant funds the visit outright, so this chip is independent of the
            plan chip above — at most one of the two ever draws for a given visit. */}
        <GrantVisitBadge className='ml-sp-1 shrink-0 self-center' coverage={readVisitCoverage(visitInfo)} />
      </div>
      {/*
       // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
      <PatientInfoCardRows infoConfig={mockPatientInfoConfig} />
    </div>
  )
}
